/**
 * @module main
 * @description Punto de entrada de la aplicación React ACSGC.
 *
 * Monta el componente raíz `App` en el elemento `#root` del HTML con `StrictMode`
 * activado para detectar efectos secundarios y APIs obsoletas en desarrollo.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
